import { useSetState } from 'react-hanger';
import { request } from 'lib';
import { useEffect } from 'react';
import FamilyList from './components/family-list';

import familyStyle from './static/styles/family.module.scss';
import { LoadingBlock } from 'components';

const a = familyStyle.a;

const Index = (props) => {
  const { state, setState } = useSetState(null);

  const reqConfig = {
    family_room_list: { url: 'public/family_room_list?size=20' },
    family_new: { url: 'public/family_list?size=6&page=1&type=3&sort=-1' },
    family_rank: { url: 'rank/family_rank?size=5' },
    family_rank_last: { url: 'rank/last_family_rank/3' },
    family_hot: {
      url: 'public/family_list?size=24&page=1&type=1&sort=-1',
      all: true,
    },
  };

  const loadData = (key, opt) => {
    return request[opt.host || 'api'].get(opt.url);
  };

  useEffect(() => {
    const loadAllData = async () => {
      const reqs = Object.keys(reqConfig);
      const data = {};
      Promise.all(
        reqs.map((key) => {
          return loadData(key, reqConfig[key]);
        }),
      ).then((res) => {
        console.log('all data res', res);
        res.map((item, index) => {
          data[reqs[index]] =
            res[index].data?.data?.items ||
            res[index].data?.items ||
            res[index].data;
        });

        data['family_hot_count'] = res[4].rows;

        setState(data);
        console.log('all data', data);

        import('./static/index').then(() => {});
      });
    };

    loadAllData();
  }, []);

  if (!state) {
    return <LoadingBlock page></LoadingBlock>;
  }
  return (
    <>
      <script src="//lib.sumeme.com/base/scripts/ui/pagination/pagination.js"></script>
      <div id="main" className="container main">
        <div className="family-week fix">
          <div className="family-week-item" id="j_family_rank">
            <div className="module-title">
              本周荣耀家族
              <a
                id="j_btn_refresh_rank"
                className="family-refresh iconfont icon-shuaxin2"
                title="点击刷新"
              ></a>
            </div>
            {state.family_rank.map((item, i) => {
              if (i === 0) {
                return (
                  <div className="rank-item" key={item._id}>
                    <a
                      href={`/family/${item._id}`}
                      target="familyinfo"
                      className="rank-item-img"
                    >
                      <img src={item.family_pic} alt={item.family_name} />
                      <i className="icon-base icon-base-rank-1"></i>
                    </a>
                    <span
                      className={`familyIcon ${
                        item.week_support ? 'familyFirstIcon' : ''
                      }`}
                      style={{ float: 'left' }}
                      title={item.badge_name}
                    >
                      {item.badge_name}
                    </span>
                    <a
                      href={`/family/${item._id}`}
                      target="familyinfo"
                      className="text-overflow rank-item-name"
                    >
                      {item.family_name}
                    </a>
                    <span className="rank-item-val">贡献值：{item.cost}</span>
                  </div>
                );
              } else {
                return (
                  <div
                    key={item._id}
                    className={`rank-gray-item ${
                      i == 4 ? ' rank-gray-item-last' : ''
                    }`}
                  >
                    <span className="rank-gray-num icon-family">{i + 1}</span>
                    <span
                      className={`familyIcon ${
                        item.week_support ? 'familyFirstIcon' : ''
                      }`}
                      title={item.badge_name}
                    >
                      {item.badge_name}
                    </span>
                    <a
                      href={`/family/${item._id}`}
                      target="familyinfo"
                      className="text-overflow rank-gray-item-name"
                    >
                      {item.family_name}
                    </a>
                    <span className="rank-gray-val">贡献值：{item.cost}</span>
                  </div>
                );
              }
            })}
          </div>
          <div className="family-week-item" id="j_last_family_rank">
            <div className="module-title">上周荣耀家族</div>
            {state.family_rank_last.map((item, i) => {
              return (
                <div className="rank-item">
                  <a
                    href={`/family/${item._id}`}
                    target="familyinfo"
                    className="rank-item-img"
                  >
                    <img src={item.family_pic} alt={item.family_name} />
                    <i className={`icon-base icon-base-rank-${i + 1}`}></i>
                  </a>
                  <a
                    href={`/family/${item._id}`}
                    target="familyinfo"
                    className="text-overflow rank-item-name"
                    title={item.family_name}
                  >
                    {item.family_name}
                  </a>
                  <span
                    className={`familyIcon ${
                      item.week_support ? ' familyFirstIcon' : ''
                    }`}
                    title={item.badge_name}
                  >
                    {item.badge_name}
                  </span>
                </div>
              );
            })}
          </div>
          <div className="family-week-item">
            <div className="module-title">我的家族</div>
            <div className="my-family">
              <div
                className="my-family-info"
                style={{ display: 'none' }}
                id="j_my_family_info"
              ></div>
              <div className="family-create" id="j_family_create">
                <a
                  className="btn-primary btn-lg"
                  title="创建家族"
                  id="j_build_family"
                >
                  创建家族
                </a>
                <p>创建家族须8富及以上并支付30000柠檬</p>
              </div>
              <div className="my-family-desc">
                <h3>荣耀家族特权</h3>
                <p>1.&nbsp;荣耀家族族长获得天狼专属座驾</p>
                <p>2.&nbsp;荣耀家族成员根据贡献值获得经验加成</p>
                <p>3.&nbsp;荣耀家族族长获得荣耀礼包分发权</p>
                <p>4.&nbsp;荣耀家族成员获得黄金徽章</p>
              </div>
              <span className="icon-family my-family-rongyao"></span>
              <a
                className="icon-q iconfont icon-yiwen"
                href="/notice/282"
                target="_blank"
                title="帮助"
              ></a>
            </div>
          </div>
        </div>

        <div className="family-all">
          <div className="module-title" id="all">
            全部家族
          </div>
          <ul className="mod-hd-sort" id="j_family_sort">
            <li>
              <a className="on" data-type="hot">
                热门家族
              </a>
            </li>
            <li>
              <a data-type="time">最新创建</a>
            </li>
            <li>
              <a data-type="member">成员人数</a>
            </li>
          </ul>
          <div className="family-list fix" id="j_family_all">
            <FamilyList data={state.family_hot}></FamilyList>
          </div>
          <div
            className="ui-pager"
            id="j_family_pager"
            data-count={state.family_hot_count}
          ></div>
        </div>
      </div>
    </>
  );
};

Index.getInitialProps = async (ctx) => {
  return {
    currentPage: 'family',
  };
};

export default Index;
